import { HasuraBaseQuery } from '@anduin/shared';
import { IServerSideGetRowsParams } from 'ag-grid-community';
import { Apollo } from 'apollo-angular';
import { applyRequestSnapshot, TableRequestSnapshot } from '../../../utils';
import { FailedEmailDatasource } from './failed-datasource.service';

export class FailedEmailExportDatasource extends FailedEmailDatasource {
  constructor(
    apollo: Apollo,
    baseQuery: HasuraBaseQuery,
    private readonly requestSnapshot: TableRequestSnapshot,
  ) {
    super(apollo, baseQuery);
  }

  getRows(params: IServerSideGetRowsParams): void {
    super.getRows(applyRequestSnapshot(params, this.requestSnapshot));
  }
}
